import { Button } from '@rematter/ui-web';
import { useAtom } from 'jotai';

import { $brokeredLoadForm } from '../../_state/brokeredLoadDetail.state';
import { useTranslations } from '../../i18n/useTranslations';
import { BrokeredLoadFormState } from '../../types/brokeredLoad';

type Props = {
  isSaving?: boolean;
  onSaveUpdates?: (data?: BrokeredLoadFormState) => void;
  onDiscard?: () => void;
};

export const BrokeredLoadFormFooterActions: React.FC<Props> = ({
  isSaving,
  onSaveUpdates,
  onDiscard,
}) => {
  const t = useTranslations();

  const [form] = useAtom($brokeredLoadForm);

  return (
    <div className="@BrokeredLoadFormFooterActions sticky bottom-0 mt-5 flex flex-shrink-0 justify-end gap-3 border-t border-neutral/10 bg-white px-6 py-5">
      <Button
        color="neutral"
        variant="outline"
        onPress={() => onDiscard?.()}
        isDisabled={isSaving}
      >
        {t.brokerage.loads.detail.footer.discard}
      </Button>
      <Button
        color="primary"
        variant="solid"
        onPress={() => {
          onSaveUpdates?.(form);
        }}
        isPending={isSaving}
        isLoading={isSaving}
      >
        {t.brokerage.loads.detail.footer.saveUpdates}
      </Button>
    </div>
  );
};
